import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '@services/subscription';
import { SubscriptionPlanTemplate } from '@models/subscription';

interface UseSubscriptionPlansOptions {
  enabled?: boolean;
}

export const useSubscriptionPlans = (options?: UseSubscriptionPlansOptions) => {
  return useQuery<SubscriptionPlanTemplate[]>({
    queryKey: ['subscriptionPlans'],
    queryFn: async () => {
      const response = await subscriptionService.getSubscriptionPlans();
      return response;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes - plans don't change frequently
    gcTime: 60 * 60 * 1000, // 1 hour
    retry: 1,
    enabled: options?.enabled !== false,
  });
};
